// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".unread[data-v-30dbe92d]{background-color:#f1f1f1!important;font-weight:700;border-radius:0!important;border-left:2px solid #dc3545!important}.message-info[data-v-30dbe92d]:hover,.row-message[data-v-30dbe92d]:hover,.unread[data-v-30dbe92d]:hover{color:#436f98!important}.event[data-v-30dbe92d]{cursor:pointer}.event[data-v-30dbe92d]:hover{background-color:#f2f2f2}.is-selected[data-v-30dbe92d]{background-color:#e1edf7!important}", ""]);
// Exports
module.exports = exports;
